import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
import { patientStore } from "@/store/patient";
import actionButton from "@/components/actionButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollapsibleRowActions',
    props: {
        row: Object,
        data: Object,
    },
    emits: ["action"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = patientStore();
        function rowAction(type) {
            emit("action", type);
        }
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = __props.data) === null || _a === void 0 ? void 0 : _a.actions, function (item, index) {
                return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "grid-container"
                }, [
                    _createVNode(actionButton, {
                        style: { "margin-top": "1%", "cursor": "pointer" },
                        iconname: item,
                        colorbackground: "#1A576E",
                        onCallAction: rowAction,
                        color: "red"
                    }, null, 8, ["iconname"])
                ]));
            }), 128));
        };
    }
});
